module.exports = __webpack_public_path__ + "fun_3.79ecde6d52f96a136a522d79919f4b7d.jpg";